const getDuplicatedName = (name) => {
    return `Copy of ${name}`
}

export default getDuplicatedName
